import { render, staticRenderFns } from "./inviteDetailDialog.vue?vue&type=template&id=2062a6bc&"
import script from "./inviteDetailDialog.vue?vue&type=script&lang=js&"
export * from "./inviteDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports